var map = {
	"./1.png": 1493,
	"./10.png": 1494,
	"./2.png": 1495,
	"./3.png": 1496,
	"./4.png": 1497,
	"./5.png": 1498,
	"./6.png": 1499,
	"./7.png": 1500,
	"./8.png": 1501,
	"./9.png": 1502,
	"./answer.png": 804,
	"./background1.png": 803,
	"./background2.png": 802,
	"./background3.png": 801,
	"./background4.png": 800,
	"./ch1.png": 805,
	"./che1.png": 493,
	"./che2.png": 795,
	"./che3.png": 798,
	"./che4.png": 793,
	"./che5.png": 796,
	"./che6.png": 799,
	"./che7.png": 794,
	"./che8.png": 797,
	"./che9.png": 1503,
	"./complete.png": 792
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 494;